import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { en } from './en'
import { el } from './el'

export const resources = {
  en: { translation: en },
  el: { translation: el },
}

export const LOCALE_KEY = 'bonded_locale'
export type Locale = 'en' | 'el'

export function initialLocale(): Locale {
  const stored = localStorage.getItem(LOCALE_KEY)
  if (stored === 'el' || stored === 'en') return stored
  return navigator.language.toLowerCase().startsWith('el') ? 'el' : 'en'
}

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLocale(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
